<template>
  <div>
    <default-dialog ref="dialog" fullscreen :loading="loading.pickup_location">
      <template slot="title">
        Detalhes do Local de Retira
      </template>
      <template slot="content">
        <v-expansion-panels v-model="expansion_panels" multiple flat active-class="elevation-4" popout>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-information</v-icon>
                Informações básicas
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.pickup_location = true"></f-btn>
                    </v-col>
                    <DialogEditPickupLocation
                      :dialog="dialog.pickup_location" 
                      :model_pickup_location="pickup_location?.attributes"
                      @closeDialog="dialog.pickup_location = false"
                      @updated="handleRefresh"
                    ></DialogEditPickupLocation>
                    <PickupLocationForm :pickup_location="pickup_location?.attributes" read_only ></PickupLocationForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-map</v-icon>
                Endereço
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.address = true"></f-btn>
                    </v-col>
                    <DialogEditAddress
                      :dialog="dialog.address" 
                      :model_address="pickup_location?.attributes?.address?.data?.attributes"
                      @closeDialog="dialog.address = false"
                      @updated="handleRefresh"
                    ></DialogEditAddress>
                    
                    <AddressForm :address="pickup_location?.attributes?.address?.data?.attributes" read_only ></AddressForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog>
    <dialog-loading v-if="saving" loadingText="Salvando..."></dialog-loading>
  </div>
</template>


<script>
import Api from '@/api/index';

export default {
  name: "ShowPickupLocation",
  components: {
    PickupLocationForm: ()=> import("@/_backoffice/_registrations/components/pickup_locations/forms/PickupLocationForm.vue"),
    AddressForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
    DialogEditAddress: () => import('@/_backoffice/_registrations/components/shared/edit/DialogEditAddress.vue'),
    DialogEditPickupLocation: () => import('@/_backoffice/_registrations/components/pickup_locations/DialogEditPickupLocation.vue'),
  },
  data() {
    return {
      dialog: true,
      saving: false,
      dialog: {
        address: false,
        pickup_location: false,
      },
      loading: {
        pickup_location: false,
      },
      expansion_panels: [0, 1],
      pickup_location: {},
    }
  },
  methods: {
    getData(){
      this.$refs.dialog.openDialog()
      this.getPickupLocation()
    },
    handleRefresh(){
      this.dialog.address = false
      this.dialog.pickup_location = false
      this.getData()
    },
    getPickupLocation(){
      this.loading.pickup_location = true
      let id = this.$route.params.id
      Api.PickupLocation.show(id).then((res)=>{
        this.pickup_location = {...res.data?.data}
      }).finally(()=>{
        this.loading.pickup_location = false
      })
    },
    goBack(){
      this.$router.push({name:"PickupLocations"})
    },
  },
  mounted() {
    this.getData();
  },
}
</script>
